/* global $:false */

import PusherClient from 'src/shared/pusher_client.js'

export default class PrintForm {
  static init () {
    if (!this.findElements()) { return }
    this.initBindings()
    this.subscribeToUpdates()
  }

  static findElements () {
    this.el = $('#print-modal')
    if (!(this.el.length > 0)) { return }

    this.spinner = this.el.find('.spinner')
    this.result = this.el.find('.print-results')
    this.error = this.el.find('.print-error')
    this.download_button = this.result.find('.ready')

    this.itemsField = this.el.find('[data-field=catalogue_numbers] input')
    this.departmentField = this.el.find('[data-field=department] select')

    this.departmentRefreshUrl = this.el.data('department-refresh-url')

    this.token = this.el.find('#token').val()
    this.auctionId = this.el.find('#auction_id').val()

    this.selectedButton = this.el.find('#print_type_selected')
    this.favoritesButton = this.el.find('#print_type_favorites')
    this.departmentButton = this.el.find('#print_type_department')

    this.catalogButton = this.el.find('#print_layout_catalog')
    this.listButton = this.el.find('#print_layout_list')

    this.submitButton = this.el.find('input[type=submit]')

    this.numberRegExp = /^\d+|,$/

    this.step1 = this.el.find('.step-1')
    this.step2 = this.el.find('.step-2')
    this.step3 = this.el.find('.step-3')

    return true
  }

  static subscribeToUpdates () {
    const pusher = PusherClient.connection()
    const channel = pusher.subscribe('print-job')
    channel.bind('done', data => this.doneMessage(data))
    channel.bind('progress', data => this.progressMessage(data))
    channel.bind('error', data => this.errorMessage(data))
  }

  static doneMessage (data) {
    if (data.token !== this.token) { return false }
    this.download_button.attr('href', data.link).show()
    this.spinner.hide()
    this.result.show()
  }

  static progressMessage (data) {
    if (data.token !== this.token) { return false }
    const progress = ((data.current * 100) / data.total).toString() + '%'
    $('.progress-message').html(`${data.current} / ${data.total}`)
    $('.progress .meter').css('width', progress)
  }

  static errorMessage (data) {
    if (data.token !== this.token) { return false }
    this.spinner.hide()
    this.error.show()
  }

  static itemsFieldLastChar () {
    return this.itemsField.val()[this.itemsField.val().length - 1]
  }

  static isFilled (field) {
    return field.val() !== ''
  }

  static itemsFieldFilledOut () {
    return this.isFilled(this.itemsField)
  }

  static departmentFieldFilledOut () {
    return this.isFilled(this.departmentField)
  }

  static step1SelectedOption () {
    return this.step1.find('input[name="print[type]"]:checked').val()
  }

  static step2SelectedOption () {
    return this.step2.find('input[name="print[layout]"]:checked').val()
  }

  static showStep2If (cond) {
    if (cond()) {
      this.resetPrintLayoutSelection()
      this.step2.show()
    } else {
      this.step2.hide()
    }
  }

  static showStep2IfitemsFieldFilledOut () {
    this.showStep2If(() => this.itemsFieldFilledOut())
  }

  static showStep2IfDepartmentFieldFilledOut () {
    this.showStep2If(() => this.departmentFieldFilledOut())
  }

  static step1FilledOut () {
    return ((this.step1SelectedOption() === 'selected') && this.itemsFieldFilledOut()) ||
      ((this.step1SelectedOption() === 'department') && this.departmentFieldFilledOut()) ||
      (this.step1SelectedOption() === 'favorites')
  }

  static showStep3AndEnableSubmitIfStep1And2FilledOut () {
    if (this.step1FilledOut() && (this.step2SelectedOption() != null)) {
      this.submitButton.prop('disabled', false)
      this.step3.show()
    } else {
      this.submitButton.prop('disabled', true)
      this.step3.hide()
    }
  }

  static resetAndDisableField (field) {
    field.val('').prop('disabled', true)
  }

  static resetAndDisableItemsField () {
    this.resetAndDisableField(this.itemsField)
  }

  static resetAndDisableDepartmentField () {
    this.resetAndDisableField(this.departmentField)
  }

  static resetPrintLayoutSelection () {
    this.step2.find('input[name="print[layout]"]').prop('checked', false)
  }

  static resetPrintTypeSelection () {
    this.step1.find('input[name="print[type]"]').prop('checked', false)
  }

  static reset () {
    this.error.hide()

    this.step2.hide()
    this.step3.hide()

    this.resetPrintTypeSelection()
    this.resetPrintLayoutSelection()

    this.submitButton.prop('disabled', true)

    this.resetAndDisableItemsField()
    this.resetAndDisableDepartmentField()
  }

  static initBindings () {
    this.el.find('input[type="submit"]').click(() => {
      if (this.auctionId === '') { return false }
      if (this.departmentButton.prop('checked') && (this.departmentField.val() === '')) { return false }
      if (this.selectedButton.prop('checked') && (this.itemsField.val() === '')) { return false }
      $('.print-dialog').hide('slow')
      this.spinner.show()
    })

    this.selectedButton.click(() => {
      this.itemsField.prop('disabled', false)
      this.resetAndDisableDepartmentField()

      this.showStep2IfitemsFieldFilledOut()
      this.showStep3AndEnableSubmitIfStep1And2FilledOut()
    })

    this.itemsField.keypress(e => {
      const c = String.fromCharCode(e.which)

      if (((c === ',') && (this.itemsField.val() === '')) || // Do not allow to start with ','
          ((c === '0') && (this.itemsField.val() === '')) || // Do not allow to start with '0'
          ((c === ',') && (this.itemsFieldLastChar() === ',')) || // Do not allow more than one ',' in a row
          ((c === '0') && (this.itemsFieldLastChar() === ',')) || // Do not allow to start number with '0'
          !this.numberRegExp.test(c)) {
        return false
      }
    })

    this.itemsField.keyup(() => {
      this.showStep2IfitemsFieldFilledOut()
      this.showStep3AndEnableSubmitIfStep1And2FilledOut()
    })

    this.itemsField.blur(() => {
      if (this.itemsFieldLastChar() === ',') {
        const newValue = this.itemsField.val().substring(0, this.itemsField.val().length - 1)
        this.itemsField.val(newValue).text(newValue)
      }
    })

    this.favoritesButton.click(() => {
      this.step2.show()

      this.resetAndDisableItemsField()
      this.resetAndDisableDepartmentField()
      this.resetPrintLayoutSelection()

      this.showStep3AndEnableSubmitIfStep1And2FilledOut()
    })

    this.departmentButton.click(() => {
      this.resetAndDisableItemsField()
      if (!this.departmentsLoaded) { this.fetchAvailableDepartments() }
      this.departmentField.prop('disabled', false)

      this.showStep2IfDepartmentFieldFilledOut()
      this.showStep3AndEnableSubmitIfStep1And2FilledOut()
    })

    this.departmentField.change(() => {
      this.showStep2IfDepartmentFieldFilledOut()
      this.showStep3AndEnableSubmitIfStep1And2FilledOut()
    })

    this.catalogButton.click(() => {
      this.showStep3AndEnableSubmitIfStep1And2FilledOut()
    })

    this.listButton.click(() => {
      this.showStep3AndEnableSubmitIfStep1And2FilledOut()
    })

    return $(document).on('closed.fndtn.reveal', '[data-reveal]', () => {
      this.result.hide()
      this.reset()

      $('.progress-message').html('')
      $('.progress .meter').css('width', 0)
      $('.print-dialog').show()
    })
  }

  static fetchAvailableDepartments () {
    const locale = $('html').attr('lang')

    $.ajax({
      url: this.departmentRefreshUrl,
      dataType: 'json',
      data: {
        auction_id: this.auctionId,
        locale
      }
    }).done(data => {
      $(data).each((i, department) => {
        this.departmentField.append(
          $('<option></option>')
            .attr('value', department.slug).text(department.name)
        )
      })
      this.departmentsLoaded = true
    })
  }
}
